'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.colors = exports.typography = undefined;

var _typography = require('./typography.styles');

var _typography2 = _interopRequireDefault(_typography);

var _colors = require('./colors.styles');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.typography = _typography2.default;
exports.colors = _colors2.default;


var exportedStyle = {
	typography: _typography2.default,
	colors: _colors2.default
};

exports.default = exportedStyle;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/common/styles/index.js